/**
 * devtools settings for zustand
 * @see https://github.com/pmndrs/zustand#redux-devtools
 */
export const devtoolsSettings = {
	enabled: true,
};
